// extracted by mini-css-extract-plugin
module.exports = {"filters":"AppliedFilters_filters__PL1US","tag":"AppliedFilters_tag__3CYQJ","button":"AppliedFilters_button__2BQmX"};